import React, { useState } from "react";
import FolderList from "./FolderList";
import PlayGrid from "./PlayGrid";
import logoUrl from "../../../assets/chlk-script-logo-bone.svg";

interface Props {
  onLogout: () => void;
  onAuthExpired: () => void;
}

export default function PlayBrowser({ onLogout, onAuthExpired }: Props) {
  const [selectedFolderId, setSelectedFolderId] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div className="browser">
      <div className="browser-header">
        <img className="browser-logo" src={logoUrl} alt="CHLK" />
        <button className="btn-logout" onClick={onLogout}>
          Sign out
        </button>
      </div>
      <div className="browser-search">
        <input
          type="search"
          className="browser-search-input"
          placeholder="Search plays…"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <div className="browser-body">
        <FolderList
          selectedFolderId={selectedFolderId}
          onSelect={setSelectedFolderId}
          onAuthExpired={onAuthExpired}
        />
        <PlayGrid
          folderId={selectedFolderId}
          searchQuery={searchQuery}
          onAuthExpired={onAuthExpired}
        />
      </div>
    </div>
  );
}
